<nb-card>
  <nb-card-header class="default-card-header">
    {{ 'pages.insight.asset.linked_assets' | translate }}
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      @for (asset of assets; track asset; let last = $last) {
        <nb-list-item>
          <div (click)="navigateToAsset(asset.id)" class="asset-row">
            <!-- ASSET PICTURE -->
            @if (asset.pictures?.length) {
              <div class="img-box">
                <img [src]="getThumbnailUrl(asset)" class="img-thumbnail">
              </div>
            }
            @if (!asset.pictures?.length) {
              <div class="no-img-box">
                <span>{{ "No picture" | translate }}</span>
              </div>
            }
            <div class="item-label ms-3">
              <!-- ASSET LABEL-->
              <span class="asset-label">{{ getDisplayLabel(asset) }}</span>
              <!-- INSTALLATION YEAR -->
              <span class="installation-year">{{ 'asset.installation_year' | translate }}: {{ asset.installation_year }}</span>
            </div>
          </div>
          <!-- ROW DIVIDER-->
          @if (!last) {
            <div class="asset-row-divider"></div>
          }
        </nb-list-item>
      }
    </nb-list>
  </nb-card-body>
</nb-card>